import { api } from "../../api/api";
import { AutoForm } from "../../core/form/AutoForm";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { loginSuccess } from "../../core/hooks/useSession";
import { go } from "../../core/route/Route";
import { Modal } from "../../core/ui/Modal";
import { Icon } from "../../core/ui/icons";

export function LoginModal(props: {
    onClose: () => void,
	onSuccess?: () => boolean,
}) {

	const context = useDataContext({
		initialValue: {
			email: "",
			password: "",
		},
	});

	return (
		<DataContext.Provider value={context}>

			<Modal
				title="Login"
				size="width-40vw"
				onCancel={props.onClose}
				onSave={() => {
					context.setApiStatus({ communicating: true });
					api.auth_login({
						email: context.value.email,
						password: context.value.password,
					}, context).then((res: any) => {
						loginSuccess();

						let handled = false;

						if (props.onSuccess) {
							handled = props.onSuccess();
						}

						if (!handled) {
							go("/dashboard/");	
						}

						
					}).catch((err: any) => {

					});
				}}
				saveTitle="Login"
			>

				<div className="flex vert align-start fill modal-content-padded">
					<AutoForm
						fields={[
							{ prop: "email", title: "Email", options: { wide: true } },
							{ prop: "password", title: "Password" },
						]}
					/>
					<button className="transparent inline margin-top-5 font-small">I forgot my password</button>
				</div>

			</Modal>

		</DataContext.Provider>
	)
}
